// extracted by mini-css-extract-plugin
export var container = "_qu-0";
export var table = "_qu-2";
export var tableWrapper = "_qu-1";